"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "convertQuestionModelToServiceContract", {
    enumerable: true,
    get: function() {
        return convertQuestionModelToServiceContract;
    }
});
const convertQuestionModelToServiceContract = (reviewQuestionDocument)=>{
    if (!reviewQuestionDocument || typeof reviewQuestionDocument !== "object") {
        return reviewQuestionDocument;
    }
    const { multiSelectMinimum, multiSelectMaximum, company, ...fixed } = reviewQuestionDocument;
    return {
        ...fixed,
        // Fix kebab-case fields that got incorrectly converted by snakeToCamel
        // DB: multi-select-minimum → snakeToCamel → multiSelectMinimum → fix → multiSelectMin
        ...multiSelectMinimum !== undefined && {
            multiSelectMin: multiSelectMinimum
        },
        ...multiSelectMaximum !== undefined && {
            multiSelectMax: multiSelectMaximum
        },
        // Satisfy the type for choices and addScaling
        // Convert DB value "" → undefined for rating scale options (DB stores "" for missing numeric value)
        ...Array.isArray(fixed.choices) && fixed.choices.length > 0 && typeof fixed.choices[0] === "object" && {
            choices: fixed.choices.filter((c)=>typeof c === "object").map((c)=>({
                    ...c,
                    value: c.value === "" ? undefined : c.value
                }))
        },
        ...Array.isArray(fixed.addScaling) && {
            addScaling: fixed.addScaling.map((c)=>({
                    ...c,
                    value: c.value === "" ? undefined : c.value
                }))
        }
    };
};
